const Roles = (
  state = {},
  action
) => {
  switch (action.type) {
    case 'GET_ROLES_SUCCESS':
      return {
        ...state,
        index: action.data
      }
    case 'GET_ROLE_SUCCESS':
      return {
        ...state,
        show: action.data
      }
    default:
      return state
  }
}

export default Roles
